import { Button, Menu, styled } from '@mui/material';

export const StyledButton = styled(Button)(() => ({
  '&&': {
    minWidth: '100px',
    padding: '2px 14px',
  },
}));

export const StyledButtonTrigger = styled(Button)(() => ({
  '&&': {
    padding: '2px 0',
  },
}));

export const StyledMenu = styled(Menu)(({ theme }) => ({
  marginTop: theme.spacing(2),
}));

interface StyledLockButtonProps {
  isDropdownAction?: boolean;
}

export const StyledLockButton = styled(Button)<StyledLockButtonProps>(({ theme, isDropdownAction }) => ({
  '&&': {
    backgroundColor: theme.palette.error.light,
    color: theme.palette.error.contrastText,
    minWidth: isDropdownAction ? 'auto' : '100px',
    padding: '2px 14px',

    '&:hover': {
      backgroundColor: theme.palette.error.dark,
    },
  },
}));
